export default __webpack_public_path__ + "static/media/sql.6437ad24.svg";